import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './components/header/header.component';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from './components/footer/footer.component';
import { ButtonComponent } from './components/button/button.component';
import { ToggleSwitchComponent } from './components/toggle-switch/toggle-switch.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { SpinnerComponent } from './components/spinner/spinner.component';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, DropdownComponent],
  imports: [
    CommonModule,
    TranslateModule.forRoot(),
    ButtonComponent,
    ToggleSwitchComponent,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatLabel,
    MatInputModule,
    MatOptionModule,
    MatIcon,
    MatIconButton,
    MatSelectModule,
    SpinnerComponent,
  ],
  exports: [HeaderComponent, FooterComponent, DropdownComponent],
})
export class SharedModule {}
